export function PrivacyPage() {
  return (
    <article className="reading-page page-pad">
      <h1>Privacidad en la versión demostrativa</h1>
      <p className="reading-lede">Entreventanas fue diseñada para que jugar no requiera contarle al sistema más de lo necesario.</p>
      <h2>Qué guarda esta instalación</h2>
      <p>Las salas conservan nombres de pantalla, roles, progreso, respuestas necesarias para la experiencia y un historial redactado de comandos. El correo opcional se transforma en un hash antes de almacenarse.</p>
      <h2>Qué no se envía a analítica</h2>
      <p>No se envían respuestas libres, nombres, pistas privadas, códigos de sala, tokens ni texto personalizado. Los eventos usan una lista cerrada de propiedades.</p>
      <h2>Entorno local</h2>
      <p>Por defecto, esta implementación funciona en modo demostración con una base SQLite local y sin servicios de pago, mensajería o analítica externos. Antes de un lanzamiento comercial deben definirse aviso legal, plazos de retención, mecanismos de derechos y contratos con proveedores.</p>
      <h2>Control y borrado</h2>
      <p>La base local puede eliminarse de forma controlada durante desarrollo. En producción, la eliminación deberá pasar por un flujo autenticado y auditable; no se ofrece una promesa legal hasta completar la revisión aplicable en México.</p>
    </article>
  );
}
